
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Preweddinglocationnearamravati() {



  const cardData =
  {
    keyword: ' Pre-Wedding Location Near Amravati',
    heading:  'Woodland Escape: Pre-Wedding Location Near Amravati ',
    headingDescription: 'Woodland Escape Resort, a dreamy pre-wedding location near Amravati, offers a picturesque setting surrounded by lush greenery, serene forested areas, and open lawns perfect for capturing your love story. Just a short drive from the city, the resort combines natural beauty with modern comfort, featuring thoughtfully designed cottages, shaded pathways, and charming outdoor spaces ideal for pre-wedding shoots and intimate celebrations. Couples can enjoy styled photography spots with natural light, tranquil corners for heartfelt moments, and vibrant spaces for fun pre-wedding activities with friends and family. Whether it’s an early-morning shoot, a casual gathering, or a full-day pre-wedding celebration, Woodland Escape Resort near Amravati provides a romantic and convenient backdrop to create unforgettable memories.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Pre-Wedding Location Near Amravati",
"description": "Discover the best pre-wedding locations near Amravati offering picturesque backdrops, lush greenery, and serene environments for a memorable photoshoot. Perfect for couples looking for romantic outdoor settings."
},
{
"name": "Amravati Pre Wedding Shoot Spot",
"description": "Plan your pre-wedding shoot at specially curated spots in Amravati with scenic views, gardens, riversides, and professional photography-friendly setups to capture timeless memories."
},
{
"name": "Amravati Romantic Shoot Location",
"description": "Choose from romantic locations around Amravati that provide intimate and dreamy settings for couple photography. Ideal for creating stunning pre-wedding memories in nature or resort environments."
},
{
"name": "Amravati Outdoor Pre Wedding Spot",
"description": "Opt for outdoor pre-wedding locations in Amravati featuring open landscapes, greenery, and natural light. These spots are perfect for capturing candid and vibrant couple moments."
},
{
"name": "Affordable Pre Wedding Spot Amravati",
"description": "Find budget-friendly pre-wedding locations near Amravati that combine beauty with affordability. These spots provide excellent backdrops without compromising on the visual appeal of your photos."
},
{
"name": "Amravati Resort Pre Wedding Shoot",
"description": "Select resorts near Amravati for your pre-wedding shoot offering well-maintained gardens, water features, and elegant interiors to create a blend of luxury and natural beauty in your photos."
},
{
"name": "Amravati Scenic Pre Wedding Spot",
"description": "Capture stunning pre-wedding moments at scenic locations in Amravati including hills, riversides, gardens, and parks. These locations are ideal for both sunrise and sunset photography."
},
{
"name": "Amravati Riverside Pre Wedding Location",
"description": "Riverside locations in Amravati offer a tranquil and romantic setting for pre-wedding shoots. Enjoy natural reflections, flowing water, and open skies for unforgettable pictures."
},
{
"name": "Amravati Hill Pre Wedding Spot",
"description": "Hilly terrains around Amravati provide dramatic and breathtaking pre-wedding photography backdrops. Ideal for couples seeking adventure and scenic vistas in their photos."
},
{
"name": "Amravati Couple Shoot Location",
"description": "Explore exclusive couple shoot locations in Amravati designed for intimacy, creativity, and romance. From parks to resorts, these spots cater to a variety of photography styles."
},
{
"name": "Amravati Pre Wedding Tour",
"description": "Plan a pre-wedding tour in Amravati that includes multiple picturesque locations in one day. Ideal for capturing diverse backdrops and moods in a single shoot with professional guidance."
},
{
"name": "Amravati One Day Pre Wedding Shoot",
"description": "Opt for a one-day pre-wedding shoot in Amravati with well-planned itineraries covering scenic locations, resorts, gardens, and riversides for an efficient yet memorable photography session."
},
{
"name": "Amravati Photography Spot",
"description": "Choose from top photography spots in Amravati suitable for pre-wedding, couple, and portrait shoots. These spots offer natural beauty, privacy, and excellent lighting conditions."
},
{
"name": "Amravati Booking for Pre Wedding Shoot",
"description": "Easily book your pre-wedding shoot in Amravati with advance reservation options. Access professional venues, scenic backdrops, and all necessary facilities for a smooth shoot experience."
},
{
"name": "Amravati Pre Wedding Packages",
"description": "Avail curated pre-wedding packages in Amravati that include location selection, photography services, makeup assistance, and props to create a complete and memorable photoshoot experience."
}
],
"tableData": [
["- Pre-Wedding Location Near Amravati", "- Amravati Pre Wedding Shoot Spot"],
["- Amravati Romantic Shoot Location", "- Amravati Outdoor Pre Wedding Spot"],
["- Affordable Pre Wedding Spot Amravati", "- Amravati Resort Pre Wedding Shoot"],
["- Amravati Scenic Pre Wedding Spot", "- Amravati Riverside Pre Wedding Location"],
["- Amravati Hill Pre Wedding Spot", "- Amravati Couple Shoot Location"],
["- Amravati Pre Wedding Tour", "- Amravati One Day Pre Wedding Shoot"],
["- Amravati Photography Spot", "- Amravati Booking for Pre Wedding Shoot"],
["- Amravati Pre Wedding Packages", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Scenic Pre-Wedding Location Near Amravati",
    "WhyChoosedescription": "Woodland Escape Resort provides a stunning forest setting near Amravati, perfect for pre-wedding shoots. The natural surroundings create a romantic and picturesque backdrop for capturing beautiful memories."
  },
  {
    "WhyChooseheading": "Lush Forest Ambience",
    "WhyChoosedescription": "Surrounded by dense trees and serene landscapes, the resort offers an enchanting forest environment. Couples can enjoy privacy and tranquility while taking memorable pre-wedding photographs."
  },
  {
    "WhyChooseheading": "Versatile Photography Spots",
    "WhyChoosedescription": "From forest trails and pondside views to open clearings and rustic bridges, Woodland Escape Resort offers diverse locations for creative pre-wedding photography, allowing for both candid and staged shots."
  },
  {
    "WhyChooseheading": "Comfortable Facilities for Couples",
    "WhyChoosedescription": "The resort provides comfortable spaces for dressing, makeup, and resting, ensuring a smooth and enjoyable pre-wedding shoot experience without any hassle."
  },
  {
    "WhyChooseheading": "Ideal for Small Group Shoot",
    "WhyChoosedescription": "Bring along your photographer, makeup artist, and close friends for a relaxed pre-wedding session. Woodland Escape Resort’s spacious grounds and peaceful environment make it perfect for intimate photo sessions."
  },
  {
    "WhyChooseheading": "Catering & Refreshments Available",
    "WhyChoosedescription": "Keep everyone energized with freshly prepared meals and snacks available at the resort. Enjoy local delicacies and refreshments to make your pre-wedding day comfortable and enjoyable."
  },
  {
    "WhyChooseheading": "Easily Accessible from Amravati",
    "WhyChoosedescription": "Located a short drive from Amravati, Woodland Escape Resort is convenient for couples and photographers. Spend more time capturing beautiful moments and less time traveling."
  }
]














  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a pre-wedding location near Amravati?",
    answer: "Woodland Escape Resort provides a picturesque, serene, and private setting perfect for pre-wedding photoshoots and small gatherings near Amravati. The natural beauty of the resort creates stunning backdrops for memorable moments."
  },
  {
    question: "How far is Woodland Escape Resort from Amravati city?",
    answer: "The resort is located approximately 35–40 km from Amravati, which takes about 1 to 1.5 hours by car, making it easily accessible for couples and photographers."
  },
  {
    question: "What areas of the resort are ideal for pre-wedding shoots?",
    answer: "Couples can choose from open lawns, gardens, scenic ponds, and nature trails within the resort. The versatile landscapes allow for a variety of creative photo setups."
  },
  {
    question: "Can we organize a small pre-wedding celebration at the resort?",
    answer: "Yes! Woodland Escape Resort can accommodate small pre-wedding gatherings, including mehendi or haldi functions, with customized arrangements for décor, seating, and catering."
  },
  {
    question: "Does the resort provide assistance with photography and setup?",
    answer: "While the resort offers a perfect natural backdrop, you can bring your own professional photographer or pre-arrange packages with local photographers familiar with the property for ideal setups."
  },
  {
    question: "How can we book Woodland Escape Resort for a pre-wedding event near Amravati?",
    answer: "You can contact our reservations team via phone, WhatsApp, or the website to book your preferred date. Advance booking is recommended to ensure availability and customized arrangements."
  }
];

const testimonials = [
  {
    name: "Mr. Rohan & Miss. Anjali, Amravati",
    text: "Our pre-wedding shoot at Woodland Escape Resort was magical! The greenery, open lawns, and natural light made every photo perfect. The staff was helpful and made the entire experience effortless."
  },
  {
    name: "Mr. Sameer & Miss. Priya, Amravati",
    text: "Woodland Escape Resort provided the perfect setting for our pre-wedding shoot near Amravati. The location is scenic, serene, and very photogenic. Highly recommended for couples looking for a beautiful outdoor location."
  }
];














      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pre-Wedding Location Near Amravati",
  "image": "https://woodlandescape.com/assets/images/pre-wedding-location-near-amravati.jpg",
  "description": "Capture your special moments at Woodlandescape Resort — the ideal pre-wedding location near Amravati. Enjoy scenic outdoor spots, riverside views, hill backgrounds, and professional settings for a memorable pre-wedding shoot.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "542"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/pre-wedding-location-near-amravati"
  }
};



  return (
    <div>
<Helmet>
  <title>Pre-Wedding Location Near Amravati | Scenic & Romantic Spot | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your pre-wedding shoot at Woodlandescape Resort — the top pre-wedding location near Amravati. Perfect for romantic outdoor shoots with scenic views, riverside settings, and professional photography." 
  />
  <meta 
    name="keywords" 
    content="Pre-Wedding Location Near Amravati, Amravati Pre Wedding Shoot Spot, Amravati Romantic Shoot Location, Amravati Outdoor Pre Wedding Spot, Affordable Pre Wedding Spot Amravati, Amravati Resort Pre Wedding Shoot, Amravati Scenic Pre Wedding Spot, Amravati Riverside Pre Wedding Location, Amravati Hill Pre Wedding Spot, Amravati Couple Shoot Location, Amravati Pre Wedding Tour, Amravati One Day Pre Wedding Shoot, Amravati Photography Spot, Amravati Booking for Pre Wedding Shoot, Amravati Pre Wedding Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/15.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Preweddinglocationnearamravati;